import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/laser.tsx
var Laser = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M3 21L6.09277 17.9071M3 16.5148L4.80782 15.8784M8.12062 19.1921L7.48505 21M21 6.34591L10.3516 16.994C10.2798 17.0658 10.1823 17.1062 10.0806 17.1062C9.97898 17.1062 9.8815 17.0658 9.80961 16.994L7.00664 14.1909C6.93478 14.119 6.89441 14.0215 6.89441 13.9198C6.89441 13.8182 6.93478 13.7207 7.00664 13.6488L17.6542 3L21 6.34591Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M3 21L6.09277 17.9071M3 16.5148L4.80782 15.8784M8.12062 19.1921L7.48505 21M21 6.34591L10.3516 16.994C10.2798 17.0658 10.1823 17.1062 10.0806 17.1062C9.97898 17.1062 9.8815 17.0658 9.80961 16.994L7.00664 14.1909C6.93478 14.119 6.89441 14.0215 6.89441 13.9198C6.89441 13.8182 6.93478 13.7207 7.00664 13.6488L17.6542 3L21 6.34591Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ jsx("path", {
		d: "M17.5 4L7.5 14L10 16.5L20 6.5L17.5 4Z",
		fill: "currentColor",
		stroke: "currentColor"
	})] })
});
//#endregion
export { Laser };
